import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {SlideshowControls} from 'shells/carousel/slideshow-controls';
import {Link} from 'shells/link/link';
import {FooterWithControls, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';
import {ModalTitle} from 'shells/typography/modal-title';

import {EmailSyncAllMessagesSetting} from '../../email-syncing/email-sync-all-messages-setting';
import {EmailSyncShareSetting} from '../../email-syncing/email-sync-share-setting';

import {trackModalPageLoad} from '../track-page-load';

type Props = {
    goBack: () => void;
    nextPage: string;
    currentUrl: string;
};

export function SyncPreferences(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <SpacerGroup mb={32}>
                    <ModalHeader>Nice! Let’s get your preferences right first</ModalHeader>
                    <ModalSubheader>
                        Don’t worry, we won’t start syncing anything until we know exactly how you’d
                        like to add your emails.
                    </ModalSubheader>
                </SpacerGroup>
                <SpacerGroup mb={32}>
                    <ModalTitle>Which emails would you like to sync into Nutshell?</ModalTitle>
                    <EmailSyncAllMessagesSetting
                        showSavedToast={false}
                        onError={() => {
                            // TODO: need some kind of error state?
                        }}
                        radioGroupName='sync all email messages - modal'
                    />
                </SpacerGroup>
                <SpacerGroup mb={32}>
                    <ModalTitle>Which emails should be visible to your team?</ModalTitle>
                    <EmailSyncShareSetting
                        showSavedToast={false}
                        onError={() => {
                            // TODO: need some kind of error state?
                        }}
                        radioGroupName='share synced messages - modal'
                    />
                </SpacerGroup>
            </ModalMain>
            <FooterWithControls
                controls={<SlideshowControls selectedSlide={0} slideCount={3} />}
                buttons={
                    <React.Fragment>
                        <Button variant='text' onClick={props.goBack}>
                            Back
                        </Button>
                        <Link
                            variant='button-primary'
                            size='big'
                            // @ts-expect-error
                            as={RoutedLink}
                            to={props.nextPage}
                        >
                            Next
                        </Link>
                    </React.Fragment>
                }
            />
        </RightFrame>
    );
}
